export type QuizBridgeErrorSuccessProps = {
    handleNextClick: (toHash: string) => void;
};
export type AllProductsInfo = {
    Dress?: any;
    Top?: any;
    Pant?: any;
};
export type SavedAnchorPreferncesObj = {
    anchorSizeBrand: AnchorData;

};
export type SizeQuizData = {
    Dress?: SavedAnchorPreferncesObj;
    Top?: SavedAnchorPreferncesObj;
    Pant?: SavedAnchorPreferncesObj;
};
export type AnchorData = {
    anchorBrand: string;
    anchorSize: string;
    anchorSubVendor: string;
    anchorType: string;
    productType: string;
};
export type BrandArrayPerProductTypeObj ={
    Dress?: Array<string>;
    Top?: Array<string>;
    Pant?: Array<string>;
};
export type PropsSelectBrandAndSize = {
    finalBrandArrayPerProductType: Array<string>;
    userAlreadyFilledDataForProduct: SavedAnchorPreferncesObj;
    productKey: string;
    brandSizeList: any;
    handleBrandorSizeSelect: Function;
};
export type PropsSelectBrand = {
    handleBrandItemSelect: Function;
    handleClickOnBrandInput: Function;
    handleChangeSearchText: Function;
    isFocusedBrand: boolean;
    finalBrandList: Array<string>;
    selectedBrand: string | undefined;
    productKey: string;
    searchText: string | undefined;
};
export type PropsSelectSize = {
    selectedSize: string | undefined;
    selectedBrand: string | undefined;
    isFocusedSize: boolean;
    isFocusedBrand: boolean;
    productKey: string;
    brandSizeList: any;
    handleSizeItemSelect: Function;
    handleClickOnSizeInput: Function;
};
export type QueryObj = {
    includeSizeMeasure: string;
    structuredResponse: string;
    categorizeByProductType: string;
    productType?: string;
};
export const SizeQuizGlobalConstants = {
  SUCCESS: 'success',
  QUIZ: 'quiz',
  ERROR: 'error',
  BRIDGE: 'bridge',
  CREATE_AN_ACCOUNT: 'create_account',
  SIZE_QUIZ_SUCCESS_SIZE: 'size_quiz_success_size',
  SIZE_QUIZ_SUCCESS_YOUR_SIZE: 'size_quiz_success_your_size',
  APP_DATA_KEY_FOR_ANCHOR_PREFERENCES: 'favourite_brand_size_per_collection_category',
  APP_DATA_USER_SIZE_QUIZ_STATUS: 'has_user_seen_size_quiz',
  PRODUCT_TYPES: ['Dress', 'Top', 'Pant'],
  MAX_SUFFIX: 'Max',
  MIN_SUFFIX: 'Min',
  PRESENT_SUFFIX: 'Present',
  GA_EVENT_SELECT_BRAND_MAP: {
    Dress: 'SelectDressBrand',
    Top: 'SelectTopBrand',
    Pant: 'SelectPantsBrand'
  },
  GA_EVENT_SELECT_SIZE_MAP: {
    Dress: 'SelectDressSize',
    Top: 'SelectTopSize',
    Pant: 'SelectPantsSize'
  },
  GA_EVENT_DROPDOWN_MAP: {
    Dress: 'ClickDressBrandDropDown',
    Top: 'ClickTopBrandDropDown',
    Pant: 'ClickPantsBrandDropDown'
  },
  GA_SCROLL_EVENT_MAP: {
    Dress: 'ScrolledDressBrandDropDown',
    Top: 'ScrolledTopBrandDropDown',
    Pant: 'ScrolledPantsBrandDropDown'
  },
  QUERY_OBJ: {
    includeSizeMeasure: 'true',
    structuredResponse: 'true',
    categorizeByProductType: 'false'
  },
  SIZE_PROPERTY_NAME: ['bust', 'waist', 'highHip', 'hip', 'thigh']

};
